import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "row mb-2" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label small" }, "Testo", -1)),
      _withDirectives(_createElementVNode("textarea", {
        class: "form-control form-control-sm",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.text) = $event)),
        rows: "3"
      }, null, 512), [
        [_vModelText, _ctx.item.text]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label small" }, "Font Size", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.fontSize) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.item.fontSize,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label small" }, "Colore", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "color",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.color) = $event))
        }, null, 512), [
          [_vModelText, _ctx.item.color]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label small" }, "Font Family", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "form-select form-select-sm",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.fontFamily) = $event))
      }, _cache[11] || (_cache[11] = [
        _createElementVNode("option", null, "Arial", -1),
        _createElementVNode("option", null, "Times New Roman", -1),
        _createElementVNode("option", null, "Courier New", -1),
        _createElementVNode("option", null, "Verdana", -1),
        _createElementVNode("option", null, "Georgia", -1),
        _createElementVNode("option", null, "Helvetica", -1)
      ]), 512), [
        [_vModelSelect, _ctx.item.fontFamily]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small" }, "Font Weight", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "form-select form-select-sm",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.fontWeight) = $event))
      }, _cache[13] || (_cache[13] = [
        _createStaticVNode("<option value=\"normal\">Normal</option><option value=\"bold\">Bold</option><option value=\"100\">100</option><option value=\"300\">300</option><option value=\"500\">500</option><option value=\"700\">700</option><option value=\"900\">900</option>", 7)
      ]), 512), [
        [_vModelSelect, _ctx.item.fontWeight]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small" }, "Allineamento", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "form-select form-select-sm",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.textAlign) = $event))
      }, _cache[15] || (_cache[15] = [
        _createElementVNode("option", { value: "left" }, "Sinistra", -1),
        _createElementVNode("option", { value: "center" }, "Centro", -1),
        _createElementVNode("option", { value: "right" }, "Destra", -1)
      ]), 512), [
        [_vModelSelect, _ctx.item.textAlign]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small" }, "Larghezza (cm)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          step: "0.01",
          min: "0",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tempWidth) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.tempWidth,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label small" }, "Altezza (cm)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          step: "0.01",
          min: "0",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tempHeight) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.tempHeight,
            void 0,
            { number: true }
          ]
        ])
      ])
    ])
  ]))
}